module.exports = __webpack_public_path__ + "img/Feature.33667413.png";